import React from 'react';

import style from '../RegistrtionInfo/index.module.scss';

const HistoryInfo: React.FC = () => (
  <>
    <h1 className={style.header}>История участия в торгах</h1>

    <div className={style.description}>
      <h2 className={style.descriptionTitle}>Сервис позволяет:</h2>

      <div className={style.descriptionItems}>
        <div className={style.descriptionItem}>Проанализировать историю участия поставщика в закупках</div>
        <div className={style.descriptionItem}>
          Проанализировать данные о суммах НМЦ закупок, в которых поставщик принимал участие
        </div>
        <div className={style.descriptionItem}>
          Проанализировать частоту участия поставщика в закупочных процедурах за последние 365 календарных дней
        </div>
        <div className={style.descriptionItem}>Узнать в каких закупках поставщик был признан победителем</div>
      </div>
    </div>
  </>
);

export default HistoryInfo;
